import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SearchAccountTypeMasterComponent } from './search-account-type-master/search-account-type-master.component';
import { BranchMatserService } from 'app/masters/branch-matser.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { AccountTypeMasterModel } from 'app/masters/models/account-master.model';

@Component({
  selector: 'app-account-type-master',
  templateUrl: './account-type-master.component.html',
  styleUrls: ['./account-type-master.component.scss']
})
export class AccountTypeMasterComponent implements OnInit {
  AccountTypeMasterModeldata: AccountTypeMasterModel[] = [];
  accountTypeMasterModelobj: AccountTypeMasterModel = {};
  constructor(public dialog: MatDialog, public branchMatserService: BranchMatserService, public dashboardservice: DashboardService) { }

  ngOnInit(): void {
    this.GetAccountTypeMaster(0);
    this.cleardata();
  }
  GetAccountTypeMaster(parameter) {
    this.branchMatserService.GetAccountTypeMaster(parameter).subscribe((x: any) => {
      this.AccountTypeMasterModeldata = [];
      this.AccountTypeMasterModeldata = x;
    }, err => {
      if (err.status == 403) {
        this.dashboardservice.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardservice.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardservice.openSnackBar("API Failed", "OK");
      }
    });
  }
  /** Search Account Master */
  searchAccountTypeMaster() {
    const dialogRef = this.dialog.open(SearchAccountTypeMasterComponent, {
      panelClass: "full-width-dialog",
      // maxWidth: "100vw !important",
      height: "70%",
      width: "80%",
      disableClose: true,
      data: this.AccountTypeMasterModeldata
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined && result != 0) {
        this.accountTypeMasterModelobj = {};
        this.accountTypeMasterModelobj =JSON.parse(JSON.stringify(result));
        this.accountTypeMasterModelobj.isEdit = true;
      }
    });
  }

  cleardata() {
    this.accountTypeMasterModelobj = {};
    this.accountTypeMasterModelobj.pK_AccountTypeId = 0;
    this.accountTypeMasterModelobj.isEdit = false;
    this.accountTypeMasterModelobj.isActive = false;
  }

  saveAccountMaster(event) {
        const accountInput = this.accountTypeMasterModelobj.accountType?.trim();
    if (accountInput && (!this.accountTypeMasterModelobj.pK_AccountTypeId || this.accountTypeMasterModelobj.pK_AccountTypeId == 0)) {
        const isInputValid = this.AccountTypeMasterModeldata.some(item => item.accountType?.toLowerCase() === accountInput.toLowerCase());
        if (isInputValid) {
            this.dashboardservice.openSnackBar("Record Already Exists","OK");
            return;
        }
    }
      const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
      button.setAttribute('disabled', true);
      let payload = {
        "AccountTypeMaster": this.accountTypeMasterModelobj
      }
      this.branchMatserService.InsertAccountTypeMaster(payload).subscribe((x: any) => {
        this.GetAccountTypeMaster(0);
        this.cleardata();
        if (this.accountTypeMasterModelobj.pK_AccountTypeId > 0) {
          this.dashboardservice.openSnackBar("Record Updated Successfully", "ok");
        } else {
          this.dashboardservice.openSnackBar("Record Saved Successfully", "ok");
        }
      }, err => {
       button.removeAttribute('disabled');
        this.cleardata();
        if (err.status == 403) {
          this.dashboardservice.openSnackBar("You Don't have Permission", "OK");
        }
        else if (err.error.statusCode == 422) {
          this.dashboardservice.openSnackBar(err.error.message, "OK");
        }
        else {
          this.dashboardservice.openSnackBar("API Failed", "OK");
        }
      });
  }
}
